import { render, staticRenderFns } from "./Manifest_history.vue?vue&type=template&id=1e1c46f2&"
import script from "./Manifest_history.vue?vue&type=script&lang=js&"
export * from "./Manifest_history.vue?vue&type=script&lang=js&"
import style0 from "./Manifest_history.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports